/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/345-make-group': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 2H3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM11 6h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0-3h2v2h-2V3zM5 10H3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3H3v-2h2v2zM13 10h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"/><path pid="1" d="M14 8h-1c-1.336 0-2.591-.52-3.536-1.464S8 4.336 8 3V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v4c0 1.1.9 2 2 2h1c1.336 0 2.591.52 3.536 1.464S8 11.664 8 13v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm1 6c0 .265-.105.515-.295.705S14.265 15 14 15h-4c-.265 0-.515-.105-.705-.295S9 14.265 9 14v-1a6 6 0 00-6-6H2c-.265 0-.515-.105-.705-.295S1 6.264 1 6V2c0-.265.105-.515.295-.705S1.735 1 2 1h4c.265 0 .515.105.705.295S7 1.735 7 2v1a6 6 0 006 6h1c.265 0 .515.105.705.295S15 9.735 15 10v4z"/>'
  }
})
